<template>
  <div class="container">
    <footer>
      <hr />
      <div class="txtSize12 federal-bar-links">
        {{ t("footer.bellcanada") }} {{ currentYear }}.
        {{ t("footer.allrightsreserved") }}
      </div>
      <div class="spacer15"></div>
    </footer>
  </div>
</template>
<script lang="ts">
export default { name: "FooterBar" };
</script>
<script lang="ts" setup>
import { useI18n } from "vue-i18n";
const { t } = useI18n();
const currentYear = new Date().getFullYear();
</script>

<style scoped>
footer.footerLinkSeparator1:not(:first-child) {
  margin-left: 20px;
}

footer .footerLinkSeparator1:not(:last-child):after {
  content: " | ";
  font-size: 14px;
  color: #b4b4b4;
  position: relative;
  margin-left: 10px;
}

.txtSize12 {
  font-size: 12px;
}
.txtColor {
  color: #00549a !important;
  text-decoration: none;
}
.spacer10 {
  padding-top: 10px;
}
.spacer15 {
  padding-top: 15px;
}
.federal-bar-links {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
}
</style>
